/**
 * Configurações de localização para tabelas Vuetify 3 e outros componentes
 */
export const ptBrTableLocale = {
  // Traduções gerais
  badge: 'Insígnia',
  close: 'Fechar',
  open: 'Abrir',
  loading: 'Carregando...',
  noDataText: 'Nenhum registro encontrado',
  dataIterator: {
    noResultsText: 'Nenhum registro encontrado',
    loadingText: 'Carregando itens...',
  },
  dataTable: {
    itemsPerPageText: 'Itens por página:',
    ariaLabel: {
      sortDescending: 'Ordenado decrescente',
      sortAscending: 'Ordenado crescente',
      sortNone: 'Não ordenado',
    },
    sortBy: 'Ordenar por'
  },
  dataFooter: {
    itemsPerPageText: 'Itens por página:',
    itemsPerPageAll: 'Todos',
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    firstPage: 'Primeira página',
    lastPage: 'Última página',
    pageText: '{0}-{1} de {2}',
  },
  // Componentes específicos
  fileInput: {
    counter: '{0} arquivos',
    counterSize: '{0} arquivos ({1} no total)',
  },
  pagination: {
    ariaLabel: {
      root: 'Navegação de paginação',
      next: 'Próxima página',
      previous: 'Página anterior',
      page: 'Ir para a página {0}',
      currentPage: 'Página atual, Página {0}',
      first: 'Primeira página',
      last: 'Última página',
    },
  },
  rating: {
    ariaLabel: {
      item: 'Classificação {0} de {1}',
    },
  },
  input: {
    clear: 'Limpar',
    appendAction: 'Anexar ação',
    prependAction: 'Prepend action',
  }
}
